var _style, _rect, _g, _g2, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultGalleryView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 220",
    style: {
      enableBackground: "new 0 0 490 220"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#33414A;}\n\t.st1{fill:#505C62;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "default_gallery_view1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 490,
    height: 220
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,67.2v85.7c23.1-0.6,41.6-19.7,41.6-42.8S23.1,67.9,0,67.2z M25.7,117.7l-2.7,2.7l-11.1-11.1L23,98l2.7,2.7 l-8.6,8.6L25.7,117.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "17.1,109.1 25.7,117.7 23,120.4 11.9,109.1 23,98 25.7,100.6  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.4,110c0,23.1,18.5,42.2,41.6,42.8V67.2C466.9,67.9,448.4,86.9,448.4,110z M472.9,109.3l-8.6-8.6L467,98 l11.1,11.3L467,120.4l-2.7-2.7L472.9,109.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "464.3,100.6 467,98 478.1,109.1 467,120.4 464.3,117.7 472.9,109.1  "
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 75.5,
    y1: 75,
    x2: 75.5,
    y2: 68
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 414.5,
    y1: 176,
    x2: 414.5,
    y2: 145
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 414.5,
    y1: 75,
    x2: 414.5,
    y2: 63
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultGalleryView);
export default __webpack_public_path__ + "static/media/default_gallery_view.2813b5f3e4ea8f71d26f55d590c4e87a.svg";
export { ForwardRef as ReactComponent };